import React from "react";
import ReactSelect from "react-select";
import Datetime from "react-datetime";
import  { Option } from '../../../_metronic/helpers/MySelect';
import Select, { components } from "react-select";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import _ from "lodash";
import { isInstallationDB, statusDB } from "./LocationsList";
import Moment from "moment";
import { IconPickerItem } from "react-fa-icon-picker";
const { Option: customOption } = components;

interface LocationFilterProps {
  state: any;
  setState: React.Dispatch<React.SetStateAction<any>>;
  searchData: () => void;
  removeSearch: () => void;
}

const LocationFilter: React.FC<LocationFilterProps> = ({
  state,
  setState,
  searchData,
  removeSearch,
}) => {

    const getLabelForStatus = (status: any): string => {
        if (status === "true") {
            return "Active";
          } else if (status === "false") {
            return "Inactive";
          } else if (status === "all") {
            return "All";
          } else {
            return "Active";
          }
      };
      const getLabelForPendingInstallation = (status: any): string => {
        if (status === "true") {
            return "Yes";
          } else if (status === "false") {
            return "No";
          } else {
            return "";
          }
      };
  return (
    <div className="collapse" id="location-filter" aria-labelledby="location-filter">
          <div className="card mt-9">
            <div className="card-body w-100 p-lg-7 p-md-7 p-5">
              <div className="row mt-6">
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">Created At (From Date)</label>
                  <Datetime
                    ref={state.resetFrom}
                    closeOnSelect
                    dateFormat="YYYY-MM-DD"
                    timeFormat="HH:mm"
                    value={state.filterFromDate ? Moment(state.filterFromDate).format("YYYY-MM-DD HH:mm") : ""}
                    onChange={(e: any) => {
                      const dt = e["_d"];
                      setState({
                        filterFromDate: dt,
                      });
                    }}
                  />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">Created At (To Date)</label>
                  <Datetime
                    ref={state.resetTo}
                    closeOnSelect
                    dateFormat="YYYY-MM-DD"
                    timeFormat="HH:mm"
                    value={state.filterToDate ? Moment(state.filterToDate).format("YYYY-MM-DD HH:mm") : ""}
                    onChange={(e: any) => {
                      const dt = e["_d"];
                      setState({
                        filterToDate: dt,
                      });
                    }}
                  />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">Customers</label>
                  <ReactSelect
                    className="react-select"
                    classNamePrefix="my-react-select"
                    placeholder=""
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    onChange={(selected: any) => {
                      const value = selected?.map((e: any) => e.value);
                      setState({
                        customerSelected: selected.value,
                        filterCustomer: value,
                      });
                    }}
                    components={{
                      Option,
                    }}
                    value={state.customerSelected}
                    options={Array.from(state.customerDB).map(
                      (value: any) => {
                        return {
                          value: value.id,
                          label: value.name,
                        };
                      }
                    )}
                  />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">Location Name</label>
                  <ReactSearchAutocomplete
                    items={state.locationDB.map((location: any) => ({ name: location.name, id: location.name }))}
                    onSelect={(item: any) => {
                      setState({
                        filterName: item.name,
                      });
                    }}
                    onSearch={(keyword) => {
                      setState({
                        filterName: keyword,
                      });
                    }}
                    inputSearchString={state.filterName }
                    autoFocus
                    styling={{
                      borderRadius: '5px',
                      zIndex: 1
                    }}
                    fuseOptions={{
                      threshold: 0.2,
                    }}
                    onClear={() => {
                      setState({
                        filterName: '',
                      });
                    }}
                  />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">Location Status</label>
                  <Select
                    ref={state.resetStatus}
                    className="react-select"
                    classNamePrefix="my-react-select"
                    name="filterStatus"
                    defaultValue={{
                      label: getLabelForStatus(state.filterStatus),
                      value: state.filterStatus
                    }}
                    placeholder=""
                    onChange={(event: any) => {
                      setState({
                        filterStatus: event.value,
                      });
                    }}
                    options={Array.from(statusDB).map((value: any) => {
                      return {
                        value: value.id,
                        label: value.name,
                      };
                    })}
                  />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">Distributors</label>
                  <ReactSelect
                    className="react-select"
                    classNamePrefix="my-react-select"
                    placeholder=""
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    onChange={(selected: any) => {
                      const value = selected?.map((e: any) => e.value);
                      setState({
                        distributorSelected: selected,
                        filterDistributor: value,
                      });
                    }}
                    components={{
                      Option,
                    }}
                    value={state.distributorSelected}
                    options={Array.from(state.distributorDB).map(
                      (value: any) => {
                        return {
                          value: value.id,
                          label: value.name,
                        };
                      }
                    )}
                  />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">
                    Location Region
                  </label>
                  <ReactSelect
                    className="react-select"
                    classNamePrefix="my-react-select"
                    placeholder=""
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    onChange={(selected: any) => {
                      const value = selected?.map((e: any) => e.value);
                      setState({
                        locationRegionSelected: selected,
                        filterRegionId: value,
                      });
                    }}
                    components={{
                      Option,
                    }}
                    value={state.locationRegionSelected}
                    options={Array.from(state.locationRegionDB).map(
                      (value: any) => {
                        return {
                          value: value.id,
                          label: value.name,
                        };
                      }
                    )}
                  />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">
                    Market Segment
                  </label>
                  <ReactSelect
                    className="react-select"
                    classNamePrefix="my-react-select"
                    placeholder=""
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    onChange={(selected: any) => {
                      const value = selected?.map((e: any) => e.value);
                      setState({
                        marketSegmentSelected: selected,
                        filterMarketSegment: value,
                      });
                    }}
                    components={{
                      Option,
                    }}
                    value={state.marketSegmentSelected}
                    options={Array.from(state.marketSegmentDB).map(
                      (value: any) => {
                        return {
                          value: value.id,
                          label: value.name,
                        };
                      }
                    )}
                  />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">
                    Business Model
                  </label>
                  <ReactSelect
                    className="react-select"
                    classNamePrefix="my-react-select"
                    placeholder=""
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    onChange={(selected: any) => {
                      const value = selected?.map((e: any) => e.value);
                      setState({
                        businessModelSelected: selected,
                        filterBusinessModel: value,
                      });
                    }}
                    components={{
                      Option: customOption,
                    }}
                    value={state.businessModelSelected}
                    options={Array.from(state.businessModelDB).map(
                      (value: any) => {
                        return {
                          value: value.id,
                          label: value.name,
                          description: value.description,
                        };
                      }
                    )}
                    formatOptionLabel={({ value, label, description }: any, { context, selectValue }: any) => {
                      let isChecked = false;
                      const filter = selectValue.filter((x: any) => x.value === value);
                      if (filter.length > 0) {
                        isChecked = true;
                      }
                      return context === 'menu' ? (
                        <div>
                          <label className="form-check form-check-custom form-check-solid">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={isChecked}
                              readOnly
                            />
                            <label style={{marginLeft: '5px'}}>{label}</label>
                          </label>
                          <div className="text-muted">{description}</div>
                        </div>
                      ) : (
                        label
                      );
                    }}
                  />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">
                    Deployment Manager
                  </label>
                  <ReactSelect
                    className="react-select"
                    classNamePrefix="my-react-select"
                    placeholder=""
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    onChange={(selected: any) => {
                      const value = selected?.map((e: any) => e.value);
                      setState({
                        deploymentManagerSelected: selected,
                        filterManager: value,
                      });
                    }}
                    components={{
                      Option,
                    }}
                    value={state.deploymentManagerSelected}
                    options={Array.from(state.managerDB).map(
                      (value: any) => {
                        return {
                          value: value.id,
                          label: value.firstName,
                        };
                      }
                    )}
                  />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">
                    Location Type
                  </label>
                  <ReactSelect
                    className="react-select"
                    classNamePrefix="my-react-select"
                    placeholder=""
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    onChange={(selected: any) => {
                      const value = selected?.map((e: any) => e.value);
                      setState({
                        locationTypeSelected: selected,
                        filterType: value,
                      });
                    }}
                    components={{
                      Option: customOption,
                    }}
                    value={state.locationTypeSelected}
                    options={Array.from(state.deployTypeDB).map(
                      (value: any) => {
                        return {
                          value: value.id,
                          label: _.capitalize(_.lowerCase(value.name)),
                          description: value.description,
                        };
                      }
                    )}
                    formatOptionLabel={({ value, label, description }: any, { context, selectValue }: any) => {
                      let isChecked = false;
                      const filter = selectValue.filter((x: any) => x.value === value);
                      if (filter.length > 0) {
                        isChecked = true;
                      }
                      return context === 'menu' ? (
                        <div>
                          <label className="form-check form-check-custom form-check-solid">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={isChecked}
                              readOnly
                            />
                            <label style={{marginLeft: '5px'}}>{label}</label>
                          </label>
                          <div className="text-muted">{description}</div>
                        </div>
                      ) : (
                        label
                      );
                    }}
                  />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">
                    Filter Provider
                  </label>
                  <ReactSelect
                    className="react-select"
                    classNamePrefix="my-react-select"
                    placeholder=""
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    onChange={(selected: any) => {
                      const value = selected?.map((e: any) => e.value);
                      setState({
                        filterProviderSelected: selected,
                        filterProvider: value,
                      });
                    }}
                    components={{
                      Option,
                    }}
                    value={state.filterProviderSelected}
                    options={Array.from(state.filterProviderDB).map(
                      (value: any) => {
                        return {
                          value: value.id,
                          label: value.title,
                        };
                      }
                    )}
                  />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">Service Plan</label>
                  <ReactSelect
                    className="react-select"
                    classNamePrefix="my-react-select"
                    placeholder=""
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    onChange={(selected: any) => {
                      const value = selected?.map((e: any) => e.value);
                      setState({
                        servicePlanSelected: selected,
                        filterServicePlan: value,
                      });
                    }}
                    components={{
                      Option:customOption,
                    }}
                    value={state.servicePlanSelected}
                    options={Array.from(state.servicePlanDB).map(
                      (value: any) => {
                        return {
                          value: value.id,
                          label: value.name,
                          description: value.description,
                          indicater: value.indicater,
                        };
                      }
                    )}
                    formatOptionLabel={({ value, label, description,indicater }: any, { context, selectValue }: any) => {
                      let isChecked = false;
                      const filter = selectValue.filter((x: any) => x.value === value);
                      if (filter.length > 0) {
                        isChecked = true;
                      }
                      return context === 'menu' ? (
                        <div>
                          <label className="form-check form-check-custom form-check-solid">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={isChecked}
                              readOnly
                            />
                            <div style={{ marginLeft: '5px' }}>
                              <IconPickerItem icon={indicater} size={24} color="#000" />
                            </div>
                            <label style={{marginLeft: '5px', marginTop:"7px"}}>{label}</label>
                          </label>
                          <div className="text-muted">{description}</div>
                        </div>
                      ) : (
                        label
                      );
                    }}
                  />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fw-bold fs-4">Pending Installation</label>
                  <Select
                    ref={state.resetPendingInstallation}
                    className="react-select"
                    classNamePrefix="my-react-select"
                    name="filterPendingInstallation"
                    defaultValue={{
                      label: getLabelForPendingInstallation(state.filterPendingInstallation),
                      value: state.filterPendingInstallation
                    }}
                    placeholder=""
                    onChange={(event: any) => {
                      setState({
                        installationSelected: event.value,
                        filterPendingInstallation: event.value,
                      });
                    }}
                    options={Array.from(isInstallationDB).map((value: any) => {
                      return {
                        value: value.id,
                        label: value.name,
                      };
                    })}
                  />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fw-bold fs-4">Contract Owners</label>
                  <Select
                    className="react-select"
                    classNamePrefix="my-react-select"
                    placeholder=""
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                     onChange={(selected: any) => {
                      const value = selected?.map((e: any) => e.value);
                      setState({
                        contractOwnerSelected: selected,
                        filterContractOwner: value,
                      });
                    }}
                    components={{
                      Option: customOption,
                    }}
                    value={state.contractOwnerSelected}
                    options={Array.from(state.contractOwnerDB).map(
                      (value: any) => {
                        return {
                          value: value.id,
                          label: value.name,
                          description: value.description,
                        };
                      }
                    )}
                    formatOptionLabel={({ value, label, description }: any, { context, selectValue }: any) => {
                      let isChecked = false;
                      const filter = selectValue.filter((x: any) => x.value === value);
                      if (filter.length > 0) {
                        isChecked = true;
                      }
                      return context === 'menu' ? (
                        <div>
                          <label className="form-check form-check-custom form-check-solid">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={isChecked}
                              readOnly
                            />
                            <label style={{marginLeft: '5px'}}>{label}</label>
                          </label>
                          <div className="text-muted">{description}</div>
                        </div>
                      ) : (
                        label
                      );
                    }}                    
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3 mb-lg-4">
                  <button
                    type="submit"
                    onClick={searchData}
                    className="btn btn-primary me-4 fs-4 p-0 w-100 px-6 py-3"
                  >
                    {state.addLoading && (
                      <span
                        className="indicator-progress"
                        style={{ display: "block" }}
                      >
                        Please Wait..
                        <span className="spinner-border spinner-border-sm align-middle ms-3 mb-1"></span>
                      </span>
                    )}
                    {!state.addLoading && (
                      <span className="indicator-label">ADD FILTER</span>
                    )}
                  </button>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3 mb-lg-4">
                  <button
                    type="submit"
                    onClick={removeSearch}
                    className="btn btn-primary me-4 fs-4 p-0 w-100 px-6 py-3"
                  >
                    {state.filterLoading && (
                      <span
                        className="indicator-progress"
                        style={{ display: "block" }}
                      >
                        Please Wait..
                        <span className="spinner-border spinner-border-sm align-middle ms-3 mb-1"></span>
                      </span>
                    )}
                    {!state.filterLoading && (
                      <span className="indicator-label">RESET FILTER</span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
  );
};

export default LocationFilter;